import { render, staticRenderFns } from "./allim.vue?vue&type=template&id=9e731d92"
import script from "./allim.vue?vue&type=script&lang=js"
export * from "./allim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports